var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5848 16.0136L19.5843 26.0141C18.6914 26.907 17.1437 26.282 17.1437 25.0022V19.2876H9.04807C8.25636 19.2876 7.61943 18.6507 7.61943 17.859V12.1444C7.61943 11.3527 8.25636 10.7158 9.04807 10.7158H17.1437V5.0012C17.1437 3.72732 18.6854 3.09634 19.5843 3.98924L29.5848 13.9897C30.1384 14.5493 30.1384 15.4541 29.5848 16.0136ZM11.4291 25.7165V23.3354C11.4291 22.9426 11.1077 22.6211 10.7148 22.6211H5.71457C4.66095 22.6211 3.80971 21.7699 3.80971 20.7163V9.28712C3.80971 8.2335 4.66095 7.38227 5.71457 7.38227H10.7148C11.1077 7.38227 11.4291 7.06082 11.4291 6.66795V4.28688C11.4291 3.894 11.1077 3.57256 10.7148 3.57256H5.71457C2.55965 3.57256 0 6.13221 0 9.28712V20.7163C0 23.8712 2.55965 26.4308 5.71457 26.4308H10.7148C11.1077 26.4308 11.4291 26.1094 11.4291 25.7165Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMenuIcon);
export default __webpack_public_path__ + "static/media/logout-menu-icon.3a8d26c670e0ce3de8df1240bbbeea7b.svg";
export { ForwardRef as ReactComponent };